import React, { Component } from 'react'
import { ErrorBoundaryWrapper } from '~/components/elements'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
  errorInfo?: React.ErrorInfo | null
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    } as ErrorBoundaryState
  }

  static getDerivedStateFromError(error: Error | null): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // We can also log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo)
    this.setState({ errorInfo: errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryWrapper>
          <h2>Something went wrong.</h2>
          {this.state.error && <p>{this.state.error.toString()}</p>}
          {this.state.errorInfo && (
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.errorInfo.componentStack}
            </details>
          )}
        </ErrorBoundaryWrapper>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
